// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3NhxX","footer":"ModalUpdate_footer__2HmOr"};